import { QINIU_PUBLIC_BASE, QINIU_UPLOAD_URL } from '../utils/domains';

/**
 * 从后端获取七牛上传 token / 完整对象 key
 * 后端接口：GET /equipment/uploadCenter/getActivityUploadGetToken
 */
async function fetchQiniuToken() {
  // 通过同源后端中转，避免浏览器跨域预检失败
  const res = await fetch('/api/sem/qiniu/token', { method: 'GET', credentials: 'include' });
  const json = await res.json();
  if (json.code !== 200 || !json.data) {
    throw new Error(json.msg || '获取上传凭证失败');
  }
  return json.data;
}


/**
 * 通用七牛上传主函数
 * @param {File|Blob} file - 要上传的文件
 * @returns {Promise<{url: string, key: string, raw: any}>}
 */
export async function uploadToQiniu(file) {
  const { key, token } = await fetchQiniuToken();
  if (typeof key !== 'string' || !key.trim() || !token) {
    throw new Error('上传凭证缺少 token 或 key');
  }
  // 接口返回的 key 已包含 groupact/，与 token scope 绑定，必须原样提交。
  const objectKey = key;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('token', token);
  formData.append('key', objectKey);

  const uploadRes = await fetch(QINIU_UPLOAD_URL, {
    method: 'POST',
    body: formData,
  });
  const uploadJson = await uploadRes.json();
  if (!uploadRes.ok || uploadJson.error) {
    throw new Error(uploadJson.error || `七牛上传失败（HTTP ${uploadRes.status}）`);
  }

  // 用同一个完整 key 生成访问地址。
  const url = `${QINIU_PUBLIC_BASE.replace(/\/+$/, '')}/${objectKey.replace(/^\/+/, '')}`;

  return {
    url,
    key: objectKey,
    raw: uploadJson,
  };
}

